/* ============================================================
   bc-hero-fx.js — «Lumifil-kjølvann» over hero-bildet (19.08.2026).
   Pekeren etterlater gnister i Lumifil-fargene (L-KISS rosa,
   L-LITE oransje, L-MAX blå) som faller og slukner. Valgt av
   Jonas fra hero-effekt-demo-bcnordic.html, variant C.

   v1.1: pointermove på document (capture) — et app-injisert overlegg
   over heroen fanget alle pekerhendelser, så elementlyttere døde
   stille. Vi filtrerer selv på vertens område. Ikke flytt lytteren
   tilbake på elementet.
   v1.2: effekten avgrenset til SELVE HERO-BILDET (Jonas 19.08) —
   canvasen ligger nå i .bc-herov2__visual, og gnister slippes kun
   når pekeren er innenfor figurens område. Tekst og CTA-er berøres
   aldri. Finnes ikke figuren (retning B/C, innlogget visning),
   rendres ingen canvas og scriptet avslutter stille.

   Kjører KUN når: canvas [data-bc-hero-fx] finnes (fx_enabled),
   presis peker, viewport ≥ 900px, og ikke redusert bevegelse.
   Løkken kjører bare mens det finnes gnister og bildet er på skjermen.
   Canvas har pointer-events:none; ingen klikkflater påvirkes.
   ============================================================ */
(function () {
  'use strict';

  var canvas = document.querySelector('[data-bc-hero-fx]');
  if (!canvas) return;

  var fine = window.matchMedia('(pointer: fine)').matches;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!fine || reduced || window.innerWidth < 900) { canvas.remove(); return; }

  var host = canvas.closest('.bc-herov2__visual') || canvas.parentElement;
  var ctx = canvas.getContext('2d');
  var dpr = Math.min(window.devicePixelRatio || 1, 2);
  var W = 0, H = 0;
  var sparks = [];
  var raf = null;
  var visible = true;

  var LUMI = ['232,49,143', '245,146,31', '31,120,209'];

  function size() {
    W = host.clientWidth;
    H = host.clientHeight;
    canvas.width = W * dpr;
    canvas.height = H * dpr;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }

  function loop() {
    ctx.clearRect(0, 0, W, H);
    for (var i = sparks.length - 1; i >= 0; i--) {
      var s = sparks[i];
      s.x += s.vx; s.y += s.vy; s.vy += 0.05; s.life -= 0.022;
      if (s.life <= 0) { sparks.splice(i, 1); continue; }
      ctx.beginPath();
      ctx.arc(s.x, s.y, s.r * s.life + 0.4, 0, 6.2832);
      ctx.fillStyle = 'rgba(255,255,255,' + (s.life * 0.5) + ')';
      ctx.fill();
      ctx.beginPath();
      ctx.arc(s.x, s.y, s.r * s.life * 0.65, 0, 6.2832);
      ctx.fillStyle = 'rgba(' + s.c + ',' + (s.life * 0.95) + ')';
      ctx.fill();
    }
    if (sparks.length && visible) {
      raf = requestAnimationFrame(loop);
    } else {
      raf = null;
      ctx.clearRect(0, 0, W, H);
    }
  }

  document.addEventListener('pointermove', function (e) {
    if (!visible) return;
    var b = host.getBoundingClientRect();
    if (e.clientX < b.left || e.clientX > b.right || e.clientY < b.top || e.clientY > b.bottom) return;
    var mx = e.clientX - b.left, my = e.clientY - b.top;
    for (var k = 0; k < 3; k++) {
      sparks.push({
        x: mx + (Math.random() - 0.5) * 14,
        y: my + (Math.random() - 0.5) * 14,
        vx: (Math.random() - 0.5) * 1.4,
        vy: (Math.random() - 0.5) * 1.4 - 0.3,
        r: 2 + Math.random() * 3,
        life: 1,
        c: LUMI[Math.floor(Math.random() * LUMI.length)]
      });
    }
    if (sparks.length > 260) sparks.splice(0, sparks.length - 260);
    if (!raf) raf = requestAnimationFrame(loop);
  }, true);

  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      visible = entries[0].isIntersecting;
      if (!visible && raf) { cancelAnimationFrame(raf); raf = null; sparks.length = 0; ctx.clearRect(0, 0, W, H); }
    }).observe(host);
  }

  var t;
  window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(size, 150); });

  size();
})();
